module.exports = __webpack_public_path__ + "img/sphere03-graph-black.f0ba2927.png";